let localStorageEnabledCached = null;
export const isLocalStorageEnabled = () => {
  if (localStorageEnabledCached !== null) {
    return localStorageEnabledCached;
  }
  try {
    window.localStorage.setItem('slideshare_test', 'test');
    window.localStorage.removeItem('slideshare_test');
    localStorageEnabledCached = true;
    return localStorageEnabledCached;
  } catch (e) {
    localStorageEnabledCached = false;
    return localStorageEnabledCached;
  }
};
